/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Upload_Error_UnauthorizedInputs */

const vi_file_upload_error_unauthorized = /** @type {(inputs: File_Upload_Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiên đăng nhập đã hết hạn. Hãy đăng nhập lại rồi tải tệp lên.`)
};

/**

* @param {File_Upload_Error_UnauthorizedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const file_upload_error_unauthorized = /** @type {((inputs?: File_Upload_Error_UnauthorizedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Upload_Error_UnauthorizedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_file_upload_error_unauthorized(inputs)
});